import Icon from '@ant-design/icons'
import React, { FC, SVGProps } from 'react'

import './index.less'

interface IconButtonProps {
  onClick?: () => void
  icon?: FC<SVGProps<SVGSVGElement>>
  isActive?: boolean
  withContainer?: boolean
}

export const IconButton = ({ onClick, icon, isActive, withContainer }: IconButtonProps) => {
  return (
    <div className={`iconButton ${isActive ? 'active' : ''} ${withContainer ? 'hasContainer' : ''}`} onClick={() => (onClick ? onClick() : undefined)}>
      <Icon component={icon} />
    </div>
  )
}
